<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <div class="text-h4 mb-4 text-center">Workout Selection</div>
      </v-col>
    </v-row>
    <v-form ref="workoutSelectionForm" v-model="formValid">
      <v-row>
        <v-select
          v-model="workout"
          :items="workouts"
          outlined
          return-object
          label="Choose Workout"
          item-text="name"
          item-value="id"
        >
        </v-select>
      </v-row>

      <v-container v-if="workout != null && workout != undefined">
        <!--
        <v-row>
          <v-col cols="12">
            <v-radio-group v-model="radioMod" mandatory>
              <v-radio
                v-for="mod in modalities"
                :key="`${mod.type}-radio`"
                :label="
                  mod.name +
                  (mod.type == workout.modality.type ? ' (default)' : '')
                "
                :value="mod.type"
              >
              </v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="anPace"
              label="Anabolic pace"
              :rules="paceRules"
              :hint="paceHint('an')"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="aePace"
              :rules="paceRules"
              label="Aerobic pace"
              :hint="paceHint('ae')"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12">
            <p class="font-weight-light">
              Run: 400m and 1600m in seconds<br />
              Assault Bike: 1.2km and 4.8km in wattage<br />
              C2 Rower: 500m and 2km in seconds<br />
            </p>
          </v-col>
        </v-row>-->
        <v-row justify="center">
          <v-col class="text-center">
            <span v-html="workout.description"></span>
          </v-col>
        </v-row>
        <v-row>
          <v-btn :disabled="!formValid" @click="formSubmit">
            Load Workout
          </v-btn>
        </v-row>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
import workouts from "../../public/data/example.json";

export default {
  name: "WorkoutSelectionForm",
  data: function () {
    return {
      workouts: workouts,
      workout: null,
      autoplay: false,
      anPace: null,
      aePace: null,
      formValid: false,
      paceRules: [
        (v) => /^[1-9]\d*$/.test(v) || "Enter a whole number greater than 0",
      ],
    };
  },
  computed: {
    modalities: function () {
      if (this.workout == null || this.workout == undefined) {
        return null;
      } else if (
        this.workout.translations &&
        this.workout.translations.length > 0
      ) {
        var combined = [...this.workout.translations];
        combined.unshift(this.workout.modality);
        return combined;
      } else {
        return new Array(this.workout.modality);
      }
    },
    radioMod: function () {
      if (this.workout == null || this.workout == undefined) {
        return null;
      } else {
        return this.workout.modality.type;
      }
    },
  },
  methods: {
    formSubmit: function () {
      this.$emit("formSubmit", {
        workout: this.workout,
        autoplay: this.autoplay,
        //modality: this.radioMod,
        //anPace: this.anPace,
        //aePace: this.aePace,
      });
    },
    paceHint: function (type) {
      if (type == "ae") {
        if (this.radioMod == "RN") return "Best 1600m time in seconds";
      }
    },
  },
};
</script>
